import ko from "knockout";
import personIdValidator from "flow/common/personIdValidator";
import metaCache from "flow/utils/metaCache";

function setup(): void {
    ko.validation.rules["personId"] = {
        validator: function (value: string) {
            return personIdValidator.validatePersonId(value);
        },
        message: metaCache.lookup("FlowHtml.Translations.InvalidPersonId", "FlowHtml.Translations.InvalidPersonId")
    };

    ko.validation.registerExtenders();
}

export default {
    setup: setup
};
